import { RedirectCommand, Router, type CanActivateFn } from '@angular/router';
import { UserService } from '../../common/service/user.service';
import { inject } from '@angular/core';
import { Role } from './role.enum';
import { Constants } from '../../common/helper/Constants';
import { AuthService } from './auth.service';

/**
 * Guard that automatically redirects authenticated users based on their role:
 * - Account Managers (role: ACP_USER) to customer administration page
 * - Customers (role: ACP_CUSTOMER) with valid customerId to home
 * - Customers (role: ACP_CUSTOMER) without customerId to unauthorized page
 */
export const autoRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    if (userService.currentUser().roles.includes(Role.AccountManager)) {
      return new RedirectCommand(router.parseUrl(Constants.routes.home()));
    }

    if (userService.currentUser().roles.includes(Role.Customer)) {
      if (userService.currentUser().customerId == '') {
        return new RedirectCommand(router.parseUrl(Constants.routes.customerAssignmentMissing()));
      } else {
        return new RedirectCommand(router.parseUrl(Constants.routes.home()));
      }
    }
  }
  return true;
};
